<template>
     <b-container class="d-flex p-0">
        <div v-if="IsEditor" 
            class="d-flex align-items-center my-auto pr-2 h5"> 
            <b-icon-gear 
                style="pointer-events: all; cursor: pointer;" />
                <!-- @click="changeParameter(fieldSet)" /> -->
        </div>
        <div class="w-75 my-auto pr-1">{{ Parameter.Label }}</div>
        <b-form-input type="number"
                      :min="Parameter.Min"
                      :max="Parameter.Max"
                      :step="Parameter.Increment"
                      v-model="Parameter.Selected"
                      @keydown.prevent
                      class="p-0 w-100 text-center" />
    </b-container>
</template>

<script lang="ts">

    import { Prop, Vue} from 'vue-property-decorator';
    import Component from 'vue-class-component';
    import VueI18n from 'vue-i18n' // translation support
    import locales from "../locales/ParametersItems.json";
    import SpinnerField from '../Class/SpinnerField';

    Vue.use(VueI18n);

    @Component({
        i18n: { messages: locales }
    })
	export default class SpinnerItem extends Vue{
        /** Variant de couleur à appliquer sur le composant */
        @Prop({default: () => "secondary"})
		public Variant!: string;

        @Prop({default: () => false})
        public IsEditor!: boolean;

        @Prop()
        public Parameter!: SpinnerField;

        mounted(){
            this.$emit('child-event', 'mounted');
        }

        updated(){
            this.$emit('child-event', 'updated');
        }
    }
</script>

<style scoped>
</style>